import { render, staticRenderFns } from "./MessageTextRegExpSetupView.vue?vue&type=template&id=6ffd3fb1&scoped=true&"
import script from "./MessageTextRegExpSetupView.vue?vue&type=script&lang=ts&"
export * from "./MessageTextRegExpSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffd3fb1",
  null
  
)

export default component.exports